import axios from "axios";

export const AXIFY_SESSION_HEADER = "X-Axify-Session-Id";

function storageKey() {
  const path =
    typeof window !== "undefined" && window.location?.pathname
      ? window.location.pathname
      : "default";
  return `axify.sessionId:${path}`;
}

function getSessionStorage() {
  if (typeof window === "undefined") {
    return null;
  }
  try {
    return window.sessionStorage;
  } catch (_) {
    return null;
  }
}

function setAxiosSessionHeader(sessionId) {
  axios.defaults.headers.common[AXIFY_SESSION_HEADER] = sessionId;
}

function clearAxiosSessionHeader() {
  delete axios.defaults.headers.common[AXIFY_SESSION_HEADER];
}

export function applyStoredSessionId() {
  const storage = getSessionStorage();
  const sessionId = storage?.getItem(storageKey());
  if (sessionId) {
    setAxiosSessionHeader(sessionId);
  }
  return sessionId || "";
}

export function storeSessionId(sessionId) {
  const normalizedSessionId = typeof sessionId === "string" ? sessionId.trim() : "";
  if (!normalizedSessionId) {
    return "";
  }

  setAxiosSessionHeader(normalizedSessionId);
  const storage = getSessionStorage();
  storage?.setItem(storageKey(), normalizedSessionId);
  return normalizedSessionId;
}

export function storeSessionIdFromResponse(response) {
  return storeSessionId(
    response?.data?.session_id ||
      response?.headers?.["x-axify-session-id"] ||
      response?.headers?.[AXIFY_SESSION_HEADER]
  );
}

export function clearStoredSessionId() {
  clearAxiosSessionHeader();
  const storage = getSessionStorage();
  storage?.removeItem(storageKey());
}
